








import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import store from '@/store';
import { SET_OVERLAY_DISPLAY } from '@/store/constants/mutation-types';
@Component({
  components: {}
})
export default class HomeView extends Vue {
  @(namespace('OverLayModule').State('overlayEnable'))
  private overlayEnable;

  set overlay(value) {
    store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, value);
  }

  get overlay() {
    return this.overlayEnable;
  }
}
